"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveNarrationParts = exports.config = exports.NarrationConfigForDTService = exports.resolveCodeforVars = exports.buildPostData = exports.scanForNarrationParts = void 0;
const logger_1 = require("@sundaysky/logger");
const traverse_1 = __importDefault(require("traverse"));
const dtaasUtils_1 = require("./dtaasUtils");
const dtclient = __importStar(require("./dtclient"));
const log = (0, logger_1.logger)("narrations");
const UPDATE = Symbol("update");
const isCodeFor = (elem) => {
    return elem && elem.codefor && typeof elem.codefor == "object";
};
/**
 * find all codeFor variables in the lineup and return an array with information about each one
 * @param lineup
 * @returns {Array}
 */
const scanForNarrationParts = (lineup) => {
    let allCodeFors = [];
    lineup.forEach((scene) => {
        (0, traverse_1.default)(scene.data).forEach(function (elem) {
            if (isCodeFor(elem)) {
                allCodeFors.push({
                    update: ((content) => this.parent.node[this.key] = content),
                    codefor: elem.codefor,
                    scene: scene.name,
                    key: this.key
                });
            }
        });
    });
    return allCodeFors;
};
exports.scanForNarrationParts = scanForNarrationParts;
/**
 * The format the decision table requires to look up values
 * @param cfVariables
 * @param narrationConfig
 * @returns {*}
 */
const buildPostData = (cfVariables, narrationConfig) => {
    return cfVariables.reduce((postData, cf) => {
        const key = codeForToKey(cf, narrationConfig);
        postData[key] = (0, dtaasUtils_1.normalizeDtaasContext)(cf.codefor);
        // store the update function alonside each key, this is just a convenience since
        // when we get the response from the dt service, we will have to look up each key and find its
        // update function to set the result. this makes that easy
        // @ts-ignore
        postData[key][UPDATE] = cf.update;
        return postData;
    }, {});
};
exports.buildPostData = buildPostData;
/**
 *
 * @param cfVars an array of codefor variable definitions
 * @param context
 * @param narrationConfig
 * @returns when resolved, all cf have been replaced in the original lineup
 */
const resolveCodeforVars = (cfVars, context, narrationConfig) => {
    if (!narrationConfig.resolve) {
        throw new Error("no narration codefor resolver");
    }
    let mediaPrefix = (narrationConfig === null || narrationConfig === void 0 ? void 0 : narrationConfig.getMediaPrefix()) || "";
    // build data
    let postdata = (0, exports.buildPostData)(cfVars, narrationConfig);
    return narrationConfig.resolve(postdata)
        .then((resolved) => {
        Object.keys(resolved).forEach((key) => {
            let dtvalue = resolved[key];
            log.info(`${key} < ${mediaPrefix}${dtvalue}`);
            let updatedBody = null;
            if (dtvalue) {
                if (dtvalue.overrideCDEName && context[dtvalue.overrideCDEName] && context[dtvalue.overrideCDEName].comment && context[dtvalue.overrideCDEName].value) {
                    updatedBody = {
                        transcript: context[dtvalue.overrideCDEName].comment,
                        source: context[dtvalue.overrideCDEName].value
                    };
                }
                else if (dtvalue.value) {
                    updatedBody = {
                        transcript: dtvalue.comment,
                        source: mediaPrefix + dtvalue.value
                    };
                }
            }
            // @ts-ignore
            postdata[key][UPDATE](updatedBody);
        });
    });
};
exports.resolveCodeforVars = resolveCodeforVars;
const codeForToKey = (cfVariable, narrationConfig) => {
    const narrationPart = `Narration_${cfVariable.scene}_${cfVariable.key}`;
    return narrationConfig.tablePrefixes ? narrationConfig.tablePrefixes[narrationPart] : `${narrationConfig.tablePrefix}/${narrationPart}`;
};
/*
        uses the repository definitions to configure the url + prefix needed to
        call the decision table service
     */
class NarrationConfigForDTService {
    constructor(repos, narrator, headers, dtaasEndpoint) {
        const narrators = repos.narrators;
        if (!narrators) {
            throw new Error("no narrators in repository definition");
        }
        // if no narrator, the default is the first one listed
        if (!narrator) {
            let all = Object.keys(narrators);
            if (all.length > 0)
                narrator = all[0];
        }
        let narrDefinition = narrators[narrator];
        if (!narrDefinition) {
            throw new Error(`no definition for narrator ${narrator}`);
        }
        // the media prefix
        this.mediaPrefix = narrDefinition.carUrl;
        // the table prefix
        this.tablePrefix = narrDefinition.dtKey;
        this.tablePrefixes = narrDefinition.dtKeys; // For Hub draft - each narration part has its own dtKey
        this.passthroughHeaders = headers;
        this.dtaasEndpoint = dtaasEndpoint;
    }
    getMediaPrefix() {
        return this.mediaPrefix;
    }
    // the dt service configured via env variable
    resolve(postdata) {
        return dtclient.post(postdata, this.passthroughHeaders, this.dtaasEndpoint);
    }
    valid() {
        return this.tablePrefix || this.tablePrefixes;
    }
}
exports.NarrationConfigForDTService = NarrationConfigForDTService;
exports.config = NarrationConfigForDTService;
/**
 * Main Function, Put it all together...
 * Scan for cf variables, call DT Service, replace inline
 * @param lineup
 * @param narrator
 * @param repos
 * @param context
 * @param passthroughHeaders
 * @param dtaasEndpoint
 */
const resolveNarrationParts = (lineup, narrator, repos, context, passthroughHeaders, dtaasEndpoint) => __awaiter(void 0, void 0, void 0, function* () {
    // no narrator, skip this phase
    if (!narrator) {
        return Promise.resolve(lineup);
    }
    //build the narration configuration
    let config = new NarrationConfigForDTService(repos, narrator, passthroughHeaders, dtaasEndpoint);
    // if its invalid, skip this phase
    if (!config.valid) {
        return Promise.resolve(lineup);
    }
    let cfVars = (0, exports.scanForNarrationParts)(lineup);
    log.info("Resolving Narration Parts");
    cfVars.forEach(cf => log.info(cf));
    // call the service and replace all variables inline
    yield (0, exports.resolveCodeforVars)(cfVars, context, config);
    return lineup;
});
exports.resolveNarrationParts = resolveNarrationParts;
//# sourceMappingURL=narrations.js.map